(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  function loadFeaturedProducts() {
    const contentProdsEl = document.querySelector('.content-products');
    if (!contentProdsEl) return;

    const prodEls = contentProdsEl.querySelectorAll('[data-lazy-product-handle]');
    contentProdsEl.classList.add('is-loading');

    async function getProducts() {
      for (el of prodEls) {
        console.log(el)
        await fetch(`/products/${el.dataset.lazyProductHandle}/?section_id=product-item`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText;
            const fetchedHTML = document.implementation.createHTMLDocument();
            fetchedHTML.documentElement.innerHTML = html;
            el.replaceWith(fetchedHTML.querySelector('.card'));
          })
          .catch(() => {
            el.remove();
            alert("ex")
          });
      }
      contentProdsEl.classList.remove('is-loading');
    }

    getProducts();
  }

  document.addEventListener('DOMContentLoaded', loadFeaturedProducts);
  document.addEventListener('shopify:section:load', loadFeaturedProducts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rastrea_tu_pedido"]) return;
  try {
    
  
  // https://zipcode-api.ecohete.com/orders?email=miguelangel.maob@gmail.com&name=1204
$("#btn_rastrea").click( function() {
  var email = $('#email').val();
  var folio = $('#folio').val();
  
  $.ajax({
    url: 'https://zipcode-api.ecohete.com/orders?email='+email+'&name='+folio,
    success: function(respuesta) {
	$.each (respuesta, function (bb) {

       if(respuesta[bb].email == email && respuesta[bb].name == '#'+folio){
         location.href = respuesta[bb].order_status_url;
       }else{
         $('#error').show();
       }
    });
    },
    error: function() {
		
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
